import React from "react";
import PropTypes from "prop-types";
import PrimaryButtonLink from "components/v3/primary-button/PrimaryButtonLink";
import { BUTTON_THEME_BLUE_LARGE } from "components/v3/primary-button/themes";
import { STATUS_EXPIRED } from "common/constants/Constants";
import styles from "./styles.module.scss";

const ManageSubscriptionButton = ({ isAdmin, status, adminPanelUrl }) => {
    if (!isAdmin || status === STATUS_EXPIRED) {
        return null;
    }

    return (
        <div className={ styles.container }>
            <PrimaryButtonLink
                to={ adminPanelUrl }
                theme={ BUTTON_THEME_BLUE_LARGE }
                text="Manage this subscription"
            />
        </div>
    );
};

ManageSubscriptionButton.propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    adminPanelUrl: PropTypes.string.isRequired
};

export default ManageSubscriptionButton;
